<input
  class="form-control"
  type="date"
  [formControl]="control"
  [attr.min]="min"
  [attr.max]="max"
  (change)="change()"
  (keydown)="keyDown($event)"
  [placeholder]="placeholder"
  [pattern]="pattern"
  maxlength="10"
/>
<cx-form-errors
  [control]="control"
  prefix="formErrors.labeled.date"
  fallbackPrefix="formErrors.date"
  [translationParams]="{
    max: getDate(max) | cxDate,
    min: getDate(min) | cxDate
  }"
></cx-form-errors>
